import React, { useState, useCallback } from 'react';
import buildClassName from 'js/utils/classNameBuilder.util';
import { AccordionRow } from 'js/components/common/AccordionRow';

import { TABLE_VIEW } from '../../constants';
import { TableBodyRow } from '../TableBodyRow';
import { TableHeaderRow } from '../TableHeaderRow';

import style from './TableData.scss';

export const TableData = (props) => {
    const {
        data = {},
        classNames,
        focusIndex,
        tableRowView,
        onAccordionExpand,
        onAccordionCollapse
    } = props;
    const { headerCells: tableHeaderCells = [], rows: tableRows = [] } = data.tableView || {};
    const { tableViewHeaderCells = [], rows: accRows = [] } = data.accordionView || {};
    const expandedByDefaultRow = accRows.find(item => item.isExpandedByDefault);
    const [expandedItemId, setExpandedItemId] = useState(expandedByDefaultRow?.id);
    const expandItem = useCallback((id) => setExpandedItemId(id), []);

    return (
        <div className={buildClassName(['tableDataContainer'], style, classNames)}>
            {tableRowView === TABLE_VIEW.TABLE
                ? (
                    <>
                        <TableHeaderRow cells={tableHeaderCells} classNames={classNames} />
                        {tableRows.map((tableRow, index) => (
                            <TableBodyRow
                                key={tableRow.id}
                                classNames={classNames}
                                cells={tableRow.rowCells}
                                isFocused={focusIndex === index}
                            />
                        ))}
                    </>
                )
                : (
                    <>
                        {Boolean(tableViewHeaderCells.length) && (
                            <TableHeaderRow cells={tableViewHeaderCells} classNames={classNames} />
                        )}
                        {accRows.map((accRow, index) => (
                            <AccordionRow
                                id={accRow.id}
                                key={accRow.id}
                                bodyCells={accRow.rowCells}
                                headerCells={accRow.headerCells}
                                isIndependentMode={false}
                                expandItem={expandItem}
                                isFocused={focusIndex === index}
                                onAccordionExpand={onAccordionExpand}
                                onAccordionCollapse={onAccordionCollapse}
                                isExpanded={expandedItemId === accRow.id}
                                classNames={{
                                    ...classNames,
                                    ...tableViewHeaderCells.length && index === 0 && {
                                        accordionContainer: style.accordionContainer
                                    }
                                }}
                            />
                        ))}
                    </>
                )
            }
        </div>
    );
};
